import { render, staticRenderFns } from "./players_summary.vue?vue&type=template&id=236b03d1"
import script from "./players_summary.vue?vue&type=script&lang=js"
export * from "./players_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports